import { tannerGray , tannerBlue } from '../colors';
import {
  ComponentsOverrides,
  ComponentsProps,
  Theme,
} from '@mui/material';

type MuiAvatar = {
  styleOverrides?: ComponentsOverrides<Theme>['MuiAvatar'];
  defaultProps?: ComponentsProps['MuiAvatar'];
};

export const MuiAvatar: MuiAvatar = {
  styleOverrides: {
    root: {
      transition: '300ms ease-out',
      backgroundColor: tannerGray[500],
      fontSize: 18,
      '&:hover': {
        backgroundColor: tannerGray[700],
      },
      '&:active': {
        backgroundColor: tannerGray[800],
      },
      '&:focus': {
        outline: `2px solid ${tannerBlue[500]}`,
        outlineOffset: '2px',
      },
      '&:focus:not(:focus-visible)': {
        outline: 'none',
      },
      '&:focus-visible': {
        outline: `2px solid ${tannerBlue[500]}`,
        outlineOffset: '2px',
        transition: 'outline-offset 150ms',
      },
    },
    colorDefault: {
      backgroundColor: tannerGray[600],
    },
    img: {
      transition: '300ms ease-out',
      '&:hover': {
        opacity: 0.8,
      },
      '&:active': {
        opacity: 0.6,
      },
    },
  },
};
